function clickTabs(tab, content) {
  $(tab).on('click', function () {
    const tabIndex = $(this).parent().index(),
      $tabParent = $(this).parents('nav'),
      $contentParent = $tabParent.next(),
      relativeContent = $contentParent.find(content).eq(tabIndex);
    $tabParent.find('.active').removeClass('active');
    $(this).addClass('active');
    $contentParent.find(content).hide();
    relativeContent.show();
  });
}

clickTabs('.map-navigation__button', '.inner-map__figure');
clickTabs('.popup__filter-links', '.popup__map');
